export const AUTO_CLOSE_DEFAULT = 3000;